import * as Yup from 'yup';

export const ResignationRequestFormSchema = Yup.object().shape({
  resignationDate: Yup.string().required('Please select a date ..!'),
  letterOfContent: Yup.string().required('Please enter Letter of content ..!'),
  reason: Yup.string().required('Please select a reason..!'),
});
